import { Link } from '@/components/Link';
import { Flex } from '@/components/Grid';
import { Text } from '@/components/Text';
import { Button } from '@/components/Button';
import { useModal } from '@/hooks/useModal';
import { getAccount, saveSearch, useAccount } from '@/resource/account';
import { AdFilterType, AdType, SortKey } from '@/resource/ad';
import { LocationItemType } from '@/resource/location';
import { decodePathSegment } from '@/util/encodePath';
import { useEffect, useState } from 'react';

type Props = {
  adType: AdType;
  filter: AdFilterType;
  sort: SortKey;
  location?: LocationItemType;
};

export function SaveSearchButton({ filter, location, adType, sort }: Props) {
  const modal = useModal();
  const { profile } = useAccount();

  const category_ids = filter.category_ids || [];
  const idList = category_ids.join(',');
  const searched = {
    ad_search_categories: category_ids,
    distance: filter.distance,
    location_id: location?.id,
    keyword: decodePathSegment(filter.keyword || ''),
    type: adType,
    sort,
  };

  const [saved, setSaved] = useState(false);
  useEffect(() => {
    setSaved(false);
  }, [filter.distance, location?.id, filter.keyword, adType, sort, idList]);

  return (
    <Button
      icon="bell"
      theme="secondary"
      iconOnly="mobile"
      disabled={saved}
      onClick={(e, refocus) => {
        if (!profile) {
          modal.open(
            {
              type: 'login',
              props: {
                title: 'Om een zoekopdracht op te slaan moet je ingelogd zijn',
              },
            },
            refocus
          );
        } else if (profile.deactivated) {
          modal.open(
            {
              type: 'message',
              props: {
                title: 'Je account is gedeactiveerd',
                description: (
                  <Text align="center">
                    <Link to={{ type: 'profile_status' }} underline>
                      Heractiveer je account
                    </Link>{' '}
                    om een zoekopdracht op te slaan.
                  </Text>
                ),
              },
            },
            refocus
          );
        } else {
          saveSearch(searched).then(() => {
            setSaved(true);
            getAccount().catch((err) => console.error(err));
            modal.open(
              {
                type: 'message',
                props: {
                  title: 'Je zoekopdracht is opgeslagen',
                  description: (
                    <Flex dir="column" gap={2}>
                      <Text align="center">
                        Vanaf nu ontvang je e-mailnotificaties als er nieuwe
                        advertenties verschijnen die voldoen aan deze
                        zoekopdracht.
                      </Text>

                      <Text align="center">
                        Je kunt je zoekopdrachten terugvinden en aanpassen{' '}
                        <Link to={{ type: 'saved_searches' }} underline>
                          binnen je account
                        </Link>
                        .
                      </Text>

                      <Text align="center">
                        Als je wilt aanpassen hoe vaak je deze notificaties
                        ontvangt kun je dit doen in{' '}
                        <Link to={{ type: 'profile_preferences' }} underline>
                          jouw voorkeuren
                        </Link>
                        .
                      </Text>
                    </Flex>
                  ),
                },
              },
              refocus
            );
          });
        }
      }}
    >
      Bewaar zoekopdracht
    </Button>
  );
}
